import React from 'react';
import { OFFER_ANCHOR } from '../data/electrical';
const LINKS = ['Terms & Conditions', 'Privacy Policy', 'Contact'];
export function Footer() {
  return <footer className="bg-navy px-4 py-3" data-id="element-68" data-mp="3ghc4m7ro7dqv">
      <div className="mx-auto max-w-3xl text-center" data-id="element-69" data-mp="32oni2w855c5s">
        <p className="text-[11px] font-bold text-white/90" data-id="element-70" data-mp="32lrmvfnoh1l1">
          © 2026 ELECTRICAL DIAGNOSTIC PRO™ — All Rights Reserved.
        </p>
        <p className="mx-auto mt-1 max-w-2xl text-[10px] font-medium leading-snug text-white/60" data-id="element-71" data-mp="3ueimm04kl8f1">
          ELECTRICAL DIAGNOSTIC PRO™ provides educational and professional
          troubleshooting resources for electrical professionals. It does not
          replace required technical education, certification, licensing,
          equipment-specific manufacturer information, applicable safety
          procedures, local regulations, electrical codes or qualified
          professional judgment.
        </p>
        <ul className="mt-1 flex flex-wrap items-center justify-center gap-x-2 gap-y-1" data-id="element-72" data-mp="2ezbb830adg6n">
          {LINKS.map((link, i) => <li key={link} className="flex items-center gap-2" data-id="element-73" data-mp="3l9sjf6xt4wpj" data-mpi={i}>
              <a href={OFFER_ANCHOR} className="text-[10px] font-semibold text-white/75 transition-colors duration-150 hover:text-volt" data-id="element-74" data-mp="3gb8xh6j7rkx6">
                {link}
              </a>
              {i < LINKS.length - 1 && <span className="text-[10px] text-white/40" aria-hidden="true" data-id="element-75" data-mp="830j3ija450h">
                  •
                </span>}
            </li>)}
        </ul>
      </div>
    </footer>;
}